import { useEffect } from "react";

export const useSpacebarEvent = (onSpace: VoidFunction) => {
  useEffect(() => {
    const eventHandler = (event: KeyboardEvent) => {
      const path = event?.composedPath() as HTMLElement[];

      if (event.key === " " && path[0].nodeName !== "INPUT" && path[0].nodeName !== "TEXTAREA") {
        onSpace();
        event.preventDefault();
      }
    };
    document.addEventListener("keydown", eventHandler);
    return () => document.removeEventListener("keydown", eventHandler);
  }, [onSpace]);
};
